// extracted by mini-css-extract-plugin
module.exports = {"animated-logo":"AnimatedLogo_animated-logo__8Tgo2","logo-svg":"AnimatedLogo_logo-svg__OwoVB","logo-path":"AnimatedLogo_logo-path__Yzvp6"};